import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link, navigate } from 'gatsby';
import React from 'react';
import FB from '../firebase';
import Hamburger from './Hamburger';
import If from './If';

import { TypeOcr } from './Types';
import { useUser } from './UserProvider';

function ResourceMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        id='Resources'
        aria-controls={open ? 'resources' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='text'
        disableElevation
        onClick={handleClick}
        color='info'
        sx={{ borderRadius: 0 }}
      >
        Resources
        <KeyboardArrowDownIcon />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        sx={{ borderRadius: 0 }}
        MenuListProps={{
          sx: { backgroundColor: 'success.dark' },
        }}
      >
        <Stack alignItems='center'>
          <Stack
            direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
            justifyContent='center'
            ml={3}
            mr={3}
          >
            <Stack>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/blogs/loquelic-literitas-the-blog/'
              >
                <Typography color='black'>BLOG</Typography>
              </MenuItem>

              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='https://manuals.noiseengineering.us/'
              >
                <Typography color='black'>MANUALS</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/artists'
              >
                <Typography color='black'>ARTISTS</Typography>
              </MenuItem>

              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/artist-application'
              >
                <Typography color='black'>
                  BE A NOISE ENGINEERING ARTIST
                </Typography>
              </MenuItem>
            </Stack>
          </Stack>
        </Stack>
      </Menu>
    </>
  );
}
function PlatformMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        id='Platform'
        aria-controls={open ? 'shop' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='text'
        disableElevation
        onClick={handleClick}
        color='info'
      >
        Platforms
        <KeyboardArrowDownIcon />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        sx={{ borderRadius: 0 }}
        MenuListProps={{
          sx: { backgroundColor: 'success.dark' },
        }}
      >
        <Stack alignItems='center'>
          <Stack
            direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
            justifyContent='center'
            ml={5}
            mr={5}
          >
            <Stack>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/platforms'
              >
                <Typography color='black'>WHAT'S A PLATFORM MODULE?</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/world-of-alia'
              >
                <Typography color='black'>WORLD OF ALIA</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/world-of-legio'
              >
                <Typography color='black'>WORLD OF LEGIO</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/world-of-versio'
              >
                <Typography color='black'>WORLD OF VERSIO</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/portal/firmware'
              >
                <Typography color='black'>SWAP FIRMWARES</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/portal/univer-inter'
              >
                <Typography color='black'>
                  UPDATE UNIVER INTER CONFIG
                </Typography>
              </MenuItem>
            </Stack>
          </Stack>
        </Stack>
      </Menu>
    </>
  );
}
function AboutMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        id='Platform'
        aria-controls={open ? 'shop' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='text'
        disableElevation
        onClick={handleClick}
        color='info'
      >
        About Us
        <KeyboardArrowDownIcon />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        sx={{ borderRadius: 0 }}
        MenuListProps={{
          sx: { backgroundColor: 'success.dark' },
        }}
      >
        <Stack alignItems='center'>
          <Stack
            direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
            justifyContent='center'
            ml={5}
            mr={5}
          >
            <Stack>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/about'
              >
                <Typography color='black'>WHO WE ARE</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/environment'
              >
                <Typography color='black'>SUSTAINABILITY STATEMENT</Typography>
              </MenuItem>

              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/retailers'
              >
                <Typography color='black'>OUR RETAILERS</Typography>
              </MenuItem>
            </Stack>
          </Stack>
        </Stack>
      </Menu>
    </>
  );
}
function Login() {
  const user = useUser();
  return (
    <>
      <If value={!user.valid}>
        <Button
          onClick={() => {
            navigate('/portal/login');
          }}
          variant='text'
          style={{ minWidth: '80px' }}
        >
          <Typography fontSize='0.88rem' color='black'>
            LOG IN
          </Typography>
        </Button>{' '}
      </If>
      <If value={user.valid}>
        <Button
          onClick={() => {
            FB.auth.signOut();
          }}
          style={{ minWidth: '80px' }}
        >
          <Typography fontSize='0.88rem' color='black'>
            LOG OUT
          </Typography>
        </Button>
      </If>
    </>
  );
}
/*function PortalMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const user = useUser();

  return (
    <>
      <Button
        id='Portal'
        aria-controls={open ? 'shop' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='text'
        disableElevation
        onClick={handleClick}
        color='info'
      >
        Customer Portal
        <KeyboardArrowDownIcon />
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        sx={{ borderRadius: 0 }}
        MenuListProps={{
          sx: { backgroundColor: 'success.dark' },
        }}
      >
        <Stack alignItems='center'>
          <Stack
            direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
            justifyContent='center'
            ml={5}
            mr={5}
          >
            <If value={!user.valid}>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/portal/login'
              >
                <Typography color='black'>LOG IN</Typography>
              </MenuItem>{' '}
            </If>
            <If value={user.valid}>
              <MenuItem
                onClick={() => {
                  FB.auth.signOut();
                }}
              >
                <Typography color='black'>LOG OUT</Typography>
              </MenuItem>
            </If>
          </Stack>
        </Stack>
      </Menu>
    </>
  );
}*/

function HelpMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        id='Help'
        aria-controls={open ? 'shop' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='text'
        disableElevation
        onClick={handleClick}
        color='info'
      >
        Support
        <KeyboardArrowDownIcon />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        sx={{ borderRadius: 0 }}
        MenuListProps={{
          sx: { backgroundColor: 'success.dark' },
        }}
      >
        <Stack alignItems='center'>
          <Stack
            direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
            justifyContent='center'
            ml={5}
            mr={5}
          >
            <Stack>
              <MenuItem onClick={handleClose} component={'a'} href='/pages/faq'>
                <Typography color='black'>FAQS</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/contact-us'
              >
                <Typography color='black'>CONTACT US</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='https://manuals.noiseengineering.us/'
              >
                <Typography color='black'>MANUALS</Typography>
              </MenuItem>
            </Stack>
          </Stack>
        </Stack>
      </Menu>
    </>
  );
}

function ShopMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        id='Shop'
        aria-controls={open ? 'shop' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='text'
        disableElevation
        onClick={handleClick}
        color='info'
        sx={{ borderRadius: 0 }}
      >
        Products
        <KeyboardArrowDownIcon />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        sx={{ borderRadius: 0 }}
        MenuListProps={{
          sx: { backgroundColor: 'success.dark' },
        }}
      >
        <Stack alignItems='center' justifyContent='space-evenly'>
          <Stack
            direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
            justifyContent='center'
            ml={5}
            mr={5}
          >
            <Stack mr={5}>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/eurorack'
              >
                <Typography color='black'>MODULES</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/new'
              >
                <TypeOcr fontSize='12px'>New</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/bundles'
              >
                <TypeOcr fontSize='12px'>Bundles</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/oscillators'
              >
                <TypeOcr fontSize='12px'>Oscillators</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/distortion'
              >
                <TypeOcr fontSize='12px'>Distortion</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/effects'
              >
                <TypeOcr fontSize='12px'>Effects</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/utilities'
              >
                <TypeOcr fontSize='12px'>Utility</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/sequencing'
              >
                <TypeOcr fontSize='12px'>Sequencing</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/modules'
              >
                <Typography color='black' mb={4}>
                  ALL MODULES
                </Typography>
              </MenuItem>
            </Stack>
            <Stack mr={5}>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/platforms'
              >
                <Typography color='black'>PLATFORMS</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/world-of-alia'
              >
                <TypeOcr fontSize='12px'>World of Alia</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/world-of-legio'
              >
                <TypeOcr fontSize='12px'>World of Legio</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/world-of-versio'
              >
                <TypeOcr fontSize='12px' mb={3}>
                  World of Versio
                </TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/accessories'
              >
                <Typography color='black'>ACCESSORIES</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/panels'
              >
                <TypeOcr fontSize='12px'>Panels/Overlays</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/clothing'
              >
                <TypeOcr fontSize='12px'>Clothing</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/accessories'
              >
                <Typography color='black'>ALL ACCESSORIES</Typography>
              </MenuItem>
            </Stack>
            <Stack>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/pedals'
              >
                <Typography color='black' mb={2}>
                  PEDALS
                </Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/software'
              >
                <Typography color='black'>PLUGINS</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/software_synth'
              >
                <TypeOcr fontSize='12px'>Synths</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/software_effects'
              >
                <TypeOcr fontSize='12px'>Effects</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/software_bundle'
              >
                <TypeOcr fontSize='12px'>Bundles</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/products/the-freequel-bundle-sinc-vereor-virt-vereor-ruina/'
              >
                <TypeOcr fontSize='12px'>Free Software</TypeOcr>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/software'
              >
                <Typography color='black' mb={2}>
                  ALL SOFTWARE
                </Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/collections/legacy'
              >
                <Typography color='black'>LEGACY PRODUCTS</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/samplepack'
              >
                <Typography color='black'>SAMPLE PACKS</Typography>
              </MenuItem>
            </Stack>
          </Stack>
          <Divider
            style={{ width: '100%' }}
            flexItem
            color='black'
            role='presentation'
          />
          <MenuItem
            onClick={handleClose}
            component={'a'}
            href='/collections/all'
          >
            <TypeOcr
              mb={3}
              mt={3}
              fontSize='14px'
              color='black'
              fontWeight='bold'
            >
              SHOP ALL
            </TypeOcr>
          </MenuItem>
        </Stack>
      </Menu>
    </>
  );
}

function Search() {
  return (
    <Link to='/search'>
      <SearchIcon
        sx={{
          ':hover': {
            color: '#71389c',
          },
        }}
      />
    </Link>
  );
}
function MainMenuLarge() {
  return (
    <Stack
      direction='row'
      sx={{ mt: 2, justifyContent: 'space-between', alignItems: 'center' }}
    >
      <ShopMenu />
      <PlatformMenu />
      <ResourceMenu />
      <AboutMenu />
      <HelpMenu />
      <Login />
      <Search />
    </Stack>
  );
}

function MainMenuSmall() {
  return <Hamburger />;
}

export default function MainMenu() {
  /* const [currentTab, setCurrentTab] = React.useState(PAGE_HOME);*/
  //const currentTab = props.tab;
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));

  if (isSmall) {
    return <MainMenuSmall />;
  } else {
    return <MainMenuLarge />;
  }
}
